import { Enum  } from "./Enum";

export const OrderShipmentTypeEnum: Enum[] = [
  { id: 'regular', name: 'Regular' }
];